export default {"src":"/_next/static/media/cor5.1895f912.svg","height":100,"width":87,"blurWidth":0,"blurHeight":0};